import React, { useEffect } from 'react';

import bannerImageStatic from '../../static/images/woolsneaker/banner-sm.jpg';
import bannerImageDesktopStatic from '../../static/images/woolsneaker/banner.jpg';
import shoeWhite1 from '../../static/images/woolsneaker/white1.png';
import shoeWhite2 from '../../static/images/woolsneaker/white2.png';
import shoeGrey1 from '../../static/images/woolsneaker/grey1.png';
import shoeGrey2 from '../../static/images/woolsneaker/grey2.png';
import shoeBlack1 from '../../static/images/woolsneaker/black1.png';
import shoeBlack2 from '../../static/images/woolsneaker/black2.png';
import shoeYellow1 from '../../static/images/woolsneaker/yellow1.png';
import shoeYellow2 from '../../static/images/woolsneaker/yellow2.png';
import shoePink1 from '../../static/images/woolsneaker/pink1.png';
import shoePink2 from '../../static/images/woolsneaker/pink2.png';
import shoeRed1 from '../../static/images/woolsneaker/red1.png';
import shoeRed2 from '../../static/images/woolsneaker/red2.png';
import shoeDarkYellow1 from '../../static/images/woolsneaker/dark-yellow1.png';
import shoeDarkYellow2 from '../../static/images/woolsneaker/dark-yellow2.png';
import shoeBlue1 from '../../static/images/woolsneaker/blue1.png';
import shoeBlue2 from '../../static/images/woolsneaker/blue2.png';
import merinoShoe from '../../static/images/woolsneaker/merino-shoe.png';
import feather1 from '../../static/images/woolsneaker/feather-1.png';
import feather2 from '../../static/images/woolsneaker/feather-2.png';
import feather3 from '../../static/images/woolsneaker/feather-3.png';
import sec4BackgroundStatic from '../../static/images/woolsneaker/sec4-bg-sm.jpg';
import sec4BackgroundDesktopStatic from '../../static/images/woolsneaker/sec4-bg.jpg';
import sec5BackgroundStatic from '../../static/images/woolsneaker/sec5-bg-sm.jpg';
import sec5BackgroundDesktopStatic from '../../static/images/woolsneaker/sec5-bg.jpg';
import sec6ImageStatic from '../../static/images/woolsneaker/stay-cool.png';
import sec7Image1Static from '../../static/images/woolsneaker/comfort-1.png';
import sec7Image2Static from '../../static/images/woolsneaker/comfort-2.png';
import sec8ImageStatic from '../../static/images/woolsneaker/footbed.png';
import sec9ShoeStatic from '../../static/images/woolsneaker/sec9-shoe.png';
import sec9ShoeWaterStatic from '../../static/images/woolsneaker/sec9-shoe-water.png';
import sec9ShoeWater2Static from '../../static/images/woolsneaker/sec9-shoe-water2.png';
import quoteStatic from './../../static/images/quote.png';
import testimonialImageStatic from './../../static/images/woolsneaker/upsell.png';

import registerAnimations from './registerAnimations';

import './WoolSneaker.scss';
import TrustpilotWidget from '../TrustpilotWidget/TrustpilotWidget';

const WoolSneaker = (props) => {
    const {
      bannerImage,
      bannerImageDesktop,
      bannerText,
      bannerPrice,
      bannerButtonText1,
      bannerButtonUrl1,
      bannerButtonText2,
      bannerButtonUrl2,

      sec2Text,

      sec3Text,
      sec3ButtonText1,
      sec3ButtonUrl1,
      sec3ButtonText2,
      sec3ButtonUrl2,

      sec4Background,
      sec4BackgroundDesktop,
      sec4Text,

      sec5Background,
      sec5BackgroundDesktop,
      sec5Text,
      sec5ButtonText1,
      sec5ButtonUrl1,
      sec5ButtonText2,
      sec5ButtonUrl2,

      sec6Text,

      sec7Text,

      sec8Text,

      sec9Text,

      testimonialText,
      testimonialButtonText1,
      testimonialButtonUrl1,
      testimonialButtonText2,
      testimonialButtonUrl2,
      testimonialImage,
    } = props;

    useEffect(() => {
      registerAnimations();
    }, [])

    return (
        <div className="landingpage-woolsneaker">

          {/* Banner */}
          <style>
            {`
                .banner {
                background: #cbd3d6 url(${bannerImage}) no-repeat 50% 0%;
                }

                @media (min-width: 568px) {
                    .banner{
                        background-image:url(${bannerImageDesktop});
                    }
                }
            `}
          </style>
          <section className="banner">
            <div className="container">
              <article className="content clearfix">
                {bannerText}
              </article>
            </div>
            <div className="cta">
              <div className="container px-0 px-md-3">
                <p className="h2 price pb-3">{bannerPrice}</p>
                <div className="row compact btn-cont">
                  <div className="col-6"><a href={bannerButtonUrl1} className="btn btn-dark btn-block mb-3">{bannerButtonText1}</a></div>
                  <div className="col-6"><a href={bannerButtonUrl2} className="btn btn-dark btn-block mb-3">{bannerButtonText2}</a></div>
                </div>
              </div>
            </div>
          </section>

          {/* Section 2 */}
          <section className="sec sec2 d-flex">
            <div className="container d-flex flex-grow-1">
              <div className="row  flex-grow-1">
                <article className="content col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mr-auto order-md-2 align-self-start pt-md-5 mt-md-5 text-right">
                  {sec2Text}
                </article>
                <div className=" col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 ml-auto text-center order-md-1 align-self-center ">
                  <figure className="figure position-relative  d-md-inline-block shoe-colors">
                    {/*<img src="images/shoe-colors.png" alt="" class="shoe" style="opacity: 0;" />*/}
                    <p className="shoe-holder shoe-holder-1"><img src={shoeWhite1} alt="" className="shoe-1" /><img src={shoeWhite2} alt="" className="shoe-2" /></p>
                    <p className="shoe-holder shoe-holder-2"><img src={shoeGrey1} alt="" className="shoe-1" /><img src={shoeGrey2} alt="" className="shoe-2" /></p>
                    <p className="shoe-holder shoe-holder-3"><img src={shoeBlack1} alt="" className="shoe-1" /><img src={shoeBlack2} alt="" className="shoe-2" /></p>
                    <p className="shoe-holder shoe-holder-4"><img src={shoeYellow1} alt="" className="shoe-1" /><img src={shoeYellow2} alt="" className="shoe-2" /></p>
                    <p className="shoe-holder shoe-holder-5"><img src={shoePink1} alt="" className="shoe-1" /><img src={shoePink2} alt="" className="shoe-2" /></p> 
                    <p className="shoe-holder shoe-holder-6"><img src={shoeRed1} alt="" className="shoe-1" /><img src={shoeRed2} alt="" className="shoe-2" /></p> 
                    <p className="shoe-holder shoe-holder-7"><img src={shoeDarkYellow1} alt="" className="shoe-1" /><img src={shoeDarkYellow2} alt="" className="shoe-2" /></p> 
                    <p className="shoe-holder shoe-holder-8"><img src={shoeBlue1} alt="" className="shoe-1" /><img src={shoeBlue2} alt="" className="shoe-2" /></p>
                  </figure>
                </div>
              </div>
            </div>
          </section> 

          {/* Section 3 */}
          <section className="sec sec3 d-flex">
            <div className="container d-flex flex-grow-1">
              <div className="row  flex-grow-1">
                <article className="content col-10 col-sm-9 col-md-6 col-lg-6 col-xl-6 mr-auto  pr-xl-4 align-self-center">
                  {sec3Text}
                  <p className="mt-lg-5 pt-xl-4 d-flex mb-0 text-center">
                    <a href={sec3ButtonUrl1} className="btn btn-dark mb-1 mr-2 btn-size-md">{sec3ButtonText1}</a>
                    <a href={sec3ButtonUrl2} className="btn btn-dark mb-1 ml-2 btn-size-md">{sec3ButtonText2}</a>
                  </p>
                </article>
                <div className=" col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 ml-auto text-center align-self-center">
                  <figure className="figure position-relative mb-0 d-md-inline-block">
                    <img src={merinoShoe} alt="" className="shoe hide animated" />
                    <img src={feather1} alt="alt" className="feather feather-1 hide animated" />
                    <img src={feather2} alt="alt" className="feather feather-2 hide animated delay-1 " />
                    <img src={feather3} alt="alt" className="feather feather-3 hide animated delay-2" />
                  </figure>
                </div>
              </div>
            </div>
          </section> 

          {/* Section 4 */}
          <style>
            {`
                .sec4 {
                  background-image: url(${sec4Background});
                }

                @media (min-width: 768px) {
                    .sec4 {
                        background-image:url(${sec4BackgroundDesktop});
                    }
                }
            `}
          </style>
          <section className="bg-white py-3 px-3 p-md-4 p-lg-5 sec4-outer">
            <div className="container-fluid sec sec4 p-4 p-sm-5 p-lg-5 d-flex">
              <div className="container px-0 d-flex flex-grow-1">
                <div className="row flex-grow-1">
                  <article className="content col-12 col-sm-6 col-md-7 col-lg-7 col-xl-6 ml-auto align-self-start align-self-md-center text-right">
                    {sec4Text}
                  </article>
                </div>
              </div>
            </div>
          </section>  

          {/* Section 5 */}
          <style>
            {`
                .sec5 {
                  background-image: url(${sec5Background});
                }

                @media (min-width: 768px) {
                    .sec5 {
                        background-image:url(${sec5BackgroundDesktop});
                    }
                }
            `}
          </style>
          <section className="sec sec5 d-flex">
            <div className="container d-flex flex-grow-1">
              <div className="row  flex-grow-1">
                <article className="content col-10 col-sm-9 col-md-6 col-lg-6 col-xl-6 mr-auto  align-self-center">
                  {sec5Text}
                  <p className="d-flex text-center text-md-left btn-group mb-0 d-md-block ">
                    <a href={sec5ButtonUrl1} className="btn btn-dark mb-1 mr-2 btn-size-md">{sec5ButtonText1}</a>
                    <a href={sec5ButtonUrl2} className="btn btn-dark mb-1 ml-2 btn-size-md">{sec5ButtonText2}</a>
                  </p>
                </article>
              </div>
            </div>
          </section> 

          {/* Section 6 */}
          <section className="sec sec6 d-flex">
            <div className="container d-flex flex-grow-1">
              <div className="row  flex-grow-1">
                <article className="content col-10 col-sm-9 col-md-6 col-lg-6 col-xl-6 mr-auto  align-self-start">
                  {sec6Text}
                </article>
                <figure className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mr-auto position-static">
                  <p className="hide animated stay-cool"><img src={sec6ImageStatic} className="stay-cool" alt="" /></p>
                </figure>
              </div>
            </div>
          </section> 
          
          {/* Section 7 */}
          <section className="sec sec7 d-flex">
            <div className="container d-flex flex-grow-1">
              <div className="row  flex-grow-1">
                <div className=" col-12 col-sm-12 col-md-6 col-lg-6 col-xl-7 ml-auto text-center align-self-start">
                  <figure className="d-inline-block position-relative comfort">
                    <img src={sec7Image1Static} className="comfort-img comfort-1 hide animated" alt="" />
                    <img src={sec7Image2Static} className="comfort-img comfort-2 hide animated position-absolute" alt="" />
                  </figure>
                </div>
                <article className="content col-10 col-sm-9 col-md-6 col-lg-6 col-xl-5 ml-auto  align-self-start text-right">
                  {sec7Text}
                </article>
              </div>
            </div>
          </section>

          {/* Section 8 */}
          <section className="sec sec8 footbed bg-dark text-white  d-flex position-relative">
            <div className="container d-flex flex-grow-1 position-static">
              <div className="row flex-grow-1">
                <article className="content-2 col-12 col-md-6 col-lg-6 col-xl-5 pt-lg-4 ml-md-auto order-md-2 align-self-center  text-right">
                  {sec8Text}
                </article>
                <figure className="col-12 col-md-6 order-md-1 align-self-center position-static">
                  <p className="hide animated fadeInLeft">
                    <img src={sec8ImageStatic} alt="" className="d-md-block footbed-img hide animated" /> 
                  </p>
                </figure>
              </div> 
            </div>
          </section>

          {/* Section 9 */}
          <section className="sec sec9 d-flex">
            <div className="container d-flex flex-grow-1">
              <div className="row  flex-grow-1">
                <article className="content col-10 col-sm-9 col-md-6 col-lg-6 col-xl-6 mr-auto  pt-xl-5 mt-xl-5">
                  {sec9Text}
                </article>
                <div className=" col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 ml-auto text-center ">
                  <figure className="figure position-relative mb-0 d-md-inline-block">
                    <img src={sec9ShoeStatic} alt="" className="shoe hide animated" />
                    <img src={sec9ShoeWaterStatic} alt="" className="shoe-water shoe-water-1 hide animated delay-2" />
                    <img src={sec9ShoeWater2Static} alt="" className="shoe-water shoe-water-2 hide animated delay-3" />
                  </figure>
                </div>
              </div>
            </div>
          </section> 
          <section className="sec sec10 py-5 testimonials">
            <div className="container">
              <p className="text-center qoute pb-4"><img src={quoteStatic} alt="" /></p>
            </div>
            
            <div className="trustBox-widget py-4 py-lg-5 mb-5">
              <div className="container">
                  <TrustpilotWidget />
              </div>
            </div>

            {/* Testimonial */}
            <div className="testimonials-products">
              <div className="container">
                <div className="row">
                  <figure className="d-none d-md-block col-12 col-md-5">
                    <p><img src={testimonialImage} alt="" /></p>
                  </figure>
                  <article className="content col-12 col-md-7 mb-lg-0 ml-md-auto">
                    {testimonialText}

                    <figure className="d-md-none"><img src={testimonialImage} alt="" /></figure>
                    <p className="btn-cont mt-5 text-center text-md-left">
                      <a href={testimonialButtonUrl1} className="btn btn-dark  d-md-inline-block mb-3 mr-2">{testimonialButtonText1}</a>
                      <a href={testimonialButtonUrl2} className="btn btn-dark  d-md-inline-block mb-3 ml-sm-3">{testimonialButtonText2}</a>
                    </p>
                  </article>
                </div>
              </div>
            </div>
          </section>
        </div>
    );
}

WoolSneaker.defaultProps = {
  bannerImage: bannerImageStatic,
  bannerImageDesktop: bannerImageDesktopStatic,
  bannerText: <><h1>WOOL <br />  SNEAKER</h1><p>Discover our lightest Merino Wool Shoe</p></>,
  bannerPrice: "€ 99",
  bannerButtonText1: 'Women',
  bannerButtonUrl1: '#',
  bannerButtonText2: 'Men',
  bannerButtonUrl2: '#',
  sec2Text: <><h2>The summer has <br /> specials colors <br /> <strong>choose yours</strong></h2><p>Cause a little bit of summer is what <br /> the whole year is all about.</p></>,
  sec3Text: <><h2>Discover the<br /> world's <strong>lightest <br /> Merino shoe</strong></h2><p>A shoe weighing only 160 grams? Hard to believe but our GIESSWEIN Wool Sneaker makes it possible. A thin layer of 3D Stretch Merino wool and an EVA sole provide exceptional walking comfort. </p> <p><strong>Proven GIESSWEIN Merino Wool 3D Stretch</strong></p><p><strong>Particularly soft, lightweight, cushioning EVA sole</strong></p><p><strong>Unique Merino footbed</strong></p></>,
  sec3ButtonText1: 'Women',
  sec3ButtonUrl1: '#',
  sec3ButtonText2: 'Men',
  sec3ButtonUrl2: '#',
  sec4Text: <><h2>Forgot your shoes?  <br /> <strong>No, just feels like it</strong></h2><p>Thanks to the fine layer of our unique Merino Wool 3D Stretch and the extra-light EVA sole, it feels like walking barefoot. The Wool Sneaker weighs just 160 grams. </p></>,
  sec4Background: sec4BackgroundStatic,
  sec4BackgroundDesktop: sec4BackgroundDesktopStatic,
  sec5Text: <><h2><strong>Merino Wool</strong> vs.  <br />stinky feet</h2><p>With merino wool bacteria have no chance to settle down. Thanks to the special structure and the self-cleaning effect of the wool, no unpleasant odour develops even after prolonged wear.</p></>,
  sec5ButtonText1: 'Women',
  sec5ButtonUrl1: '#',
  sec5ButtonText2: 'Men',
  sec5ButtonUrl2: '#',
  sec5Background: sec5BackgroundStatic,
  sec5BackgroundDesktop: sec5BackgroundDesktopStatic,
  sec6Text: <><h2>Always <br /> <strong>stay cool</strong></h2><p>Summer, sun, sunshine. Thanks to the positive basic properties of merino wool, the Wool Sneaker is temperature and moisture regulating. So you are ready for the hot days.</p></>,
  sec7Text: <><h2>EVA: <strong>Super <br /> light comfort</strong></h2><p>Our proven, shock-absorbing EVA sole ensures a high level of wearing comfort this time too. It is much more flexible, lighter and more durable than ordinary rubber soles. </p></>,
  sec8Text: <><h2>GIESSWEIN <br /> <strong>Merino Footbed</strong></h2><p>Made from 100% merino wool. An exchangeable footbed made of 100 % merino wool. Provides a pleasant soft skin feeling and increased wearing comfort.</p></>,
  sec9Text: <><h2>Off to the <br /><strong>washing machine</strong></h2><p>Your Wool Cross X is dirty? Just wash it in the washing machine (cold water, 30°C, gentle cycle, no fabric softener). Then let the shoes air-dry (not in the dryer) and they are ready for the next training session. </p></>,
  testimonialText: <><h3><strong>These Clients bought this shoe,</strong>  <br className="d-none d-md-block" /> Maybe try this one too</h3></>,
  testimonialButtonText1: 'Women',
  testimonialButtonUrl1: '#',
  testimonialButtonText2: 'Men',
  testimonialButtonUrl2: '#',
  testimonialImage: testimonialImageStatic,
}

export default WoolSneaker;